import { supabase } from './supabase';

export const sendDMNotification = async (
  targetUserId: string,
  senderName: string,
  messageContent: string,
): Promise<{ success: boolean; error?: string }> => {
  try {
    // Get session token from Supabase auth
    const { data: { session } } = await supabase.auth.getSession();

    if (!session?.access_token) {
      return { success: false, error: 'No authentication token' };
    }

    const response = await fetch('https://www.poptheballoonapp.com/api/notifications/send', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${session.access_token}`,
      },
      body: JSON.stringify({
        type: 'new-message',
        targetUserId,
        senderName,
        messageContent,
      }),
    });

    if (!response.ok) {
      const errorData = await response.text();
      return { success: false, error: `HTTP ${response.status}` };
    }

    const result = await response.json();
    return { success: result.success || result.sent };
  } catch (error) {
    return { success: false, error: error instanceof Error ? error.message : 'Unknown error' };
  }
};